module.exports = __webpack_public_path__ + "static/FiraSans-Bold-dd44f6a983d7f1fe2538b2521ce51c46.otf";